/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Forgot_CredentialsInputs */



/**
* | output |
* | --- |
* | "No passkey yet?" |
*
* @param {Auth_Login_Forgot_CredentialsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_login_forgot_credentials = /** @type {((inputs?: Auth_Login_Forgot_CredentialsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Forgot_CredentialsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keinen Passkey?")
	return /** @type {LocalizedString} */ ("No passkey yet?")
});